export default __webpack_public_path__ + "static/media/shoes15.950f9a46.jpeg";